// extracted by mini-css-extract-plugin
module.exports = {"navSocialShareLinks":"NavSocialShareLinks_navSocialShareLinks__Dti6E","socialLink":"NavSocialShareLinks_socialLink__jKXSz","mobile":"NavSocialShareLinks_mobile__xTSLn"};